export enum YearAgreementType {
  "bikes" = "",
  "parts" = "ANL_Parts",
  "dach" = "dach",
  "dk" = "ANL_Bikes_DK",
  "dekoga" = "ANL_Bikes_DE",
  "chkoga" = "ANL_Bikes_CH",
  "lapbikes" = "LAP_Bikes",
  "anlbikes" = "ANL_Bikes2",
  "ralbikes" = "RAL_Bikes",
  "wgbikes" = "WG_Bikes",
  "dachbikes" = "DACH_Bikes2",
  "ghobikes" = "GHO_Bikes",
  "general" = "general"
}
